import { render } from "./assessment-reporting.vue?vue&type=template&id=8a04116a&scoped=true"
import script from "./assessment-reporting.vue?vue&type=script&lang=js"
export * from "./assessment-reporting.vue?vue&type=script&lang=js"

import "./assessment-reporting.vue?vue&type=style&index=0&id=8a04116a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a04116a"]])

export default __exports__